export const skillSet = [
  {
    id: 1,
    title: "HTML",
    img: "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_960_720.png",
  },
  {
    id: 2,
    title: "CSS",
    img: "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_960_720.png",
  },
  {
    id: 3,
    title: "Javascript",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/768px-JavaScript-logo.png",
  },
  {
    id: 4,
    title: "Reactjs",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
  },
  {
    id: 5,
    title: "Bootstrap",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/800px-Bootstrap_logo.svg.png",
  },
  {
    id: 6,
    title: "Material UI",
    img: "https://cdn.worldvectorlogo.com/logos/material-ui-1.svg",
  },
  {
    id: 7,
    title: "Tailwind Css",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/320px-Tailwind_CSS_Logo.svg.png",
  },
  {
    id: 8,
    title: "Git",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/2048px-Git_icon.svg.png",
  },
  {
    id: 9,
    title: "Typescript",
    img: "https://icons.veryicon.com/png/o/business/vscode-program-item-icon/typescript-def.png",
  },
  {
    id: 10,
    title: "Vs code",
    img: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/visual-studio-code-icon.png",
  },
];
